module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAlElEQVQokWO0t/f8z0AGYILSjFjwIzxycI0kAxY8ckcYGBjEyNEYjc9GfE6NYmBgSCOk8T8UH4byMxkYGJYyMDDMhIpHQcUPQ/lwjfeg+BmU/4mBgeEPktwXKPsZlM/ACI1HRiyuecjAwCCHQ+4/vsDJYmBg4MIliU/jVjxyeEN1CwMDwxlybNRlgPgRr0Z8CR2rHACpxR0vMY4PZwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/11c.png
// module id = hqcq
// module chunks = 65